import { StoreState } from 'app/app.reducers';

export const getSocialCalls = (state: StoreState) => (state.conference.socialCallRoomList);

export const getIntroductionCalls = (state: StoreState) => (state.conference.introductionCallRoomList);

export const getRecording = (state: StoreState) => (state.conference.recordingResponse);
